import { render } from "./LeaveCalendarSummary.vue?vue&type=template&id=c6aa0fe8"
import script from "./LeaveCalendarSummary.vue?vue&type=script&lang=js"
export * from "./LeaveCalendarSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__